import firebase from './../../../firebase';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import WeeklySales from './../../dashboards/default/WeeklySales';
import { Row, Col, Form } from 'react-bootstrap';
import { totalOrder } from 'data/dashboard/default';
import TotalOrder from './../../dashboards/default/TotalOrder';
import BestSellingProducts from './../../dashboards/default/BestSellingProducts';
import BandwidthSaved from './../../dashboards/default/BandwidthSaved'; 
import { format } from 'date-fns'; 
import ChartBDTP from 'components/dashboards/default/TotalPayByDate';
import ChartCA from 'components/dashboards/default/TableaChiffreaffaire';
import CommissionBarChart from 'components/dashboards/default/CommissionBarChart';
import NationalityStats from 'components/dashboards/default/NationalityStats';
import { nationalities } from 'config';

const Rapports = () => {
  const [tpay, setTpay] = React.useState(0)
  const [tcom, setTCom] = React.useState(0)
  const [tvilla, setTvilla] = React.useState(0)
  const [chalett, setChaletT] = React.useState(0)
  const [boutiquet, setBoutiqueT] = React.useState(0)
  const [nationalitiesCrm, setNationalitiesCrm] = React.useState([])


  const [tappt, setTappt] = React.useState(0)
  const [tcalprice, settcalprice] = React.useState(0)

  const [years, setYears] = React.useState([]); // Liste des années disponibles
  const [selectedYear, setSelectedYear] = React.useState(new Date().getFullYear()); // Année sélectionnée

  const [tddisp, settddisp] = React.useState(0)
  const [tnbdaybook, settnbdaybook] = React.useState(0) 
  const [dataTP, setDataTP] = React.useState(null)
  const [dataCD, setDataCD] = React.useState(null)

  const [totalreservation, setTotalBooking] = React.useState(0)
  const [data, setData] = React.useState([])
  const [productsN, setproductsN] = React.useState([])
  const [l, setL] = React.useState(true);
  const navigate = useNavigate();

  function groupTotalByMonth(transactions) {
    return transactions.reduce((acc, transaction) => {
      // Extraire le mois et l'année de la date
      const year = transaction.date.getFullYear();
      const month = transaction.date.getMonth() + 1; // les mois commencent à 0, donc on ajoute 1
      const key = `${month < 10 ? '0' + month : month}/${year}`;

      // Si la clé existe, ajouter le prix à la somme existante, sinon initialiser avec le prix actuel
      acc[key] = (acc[key] || 0) + transaction.price;

      return acc;
    }, {});
  }

  function getNumberDayOfDisp(disponibilites = []) {
    // Fonction pour calculer le nombre de jours entre deux dates
    function nombreJoursEntreDeuxDates(date1, date2) {
      const unJour = 24 * 60 * 60 * 1000; // Nombre de millisecondes en un jour
      const differenceTemps = Math.abs(date1.getTime() - date2.getTime());
      return Math.round(differenceTemps / unJour);
    }

    // Variable pour stocker le nombre total de jours de disponibilité
    var totalJoursDisponibilite = 0;

    // Parcourir le tableau
    disponibilites.forEach(function (disponibilite) {
      // Convertir les chaînes de dates en objets Date
      var dateDebut = new Date(disponibilite.first);
      var dateFin = new Date(disponibilite.end);

      // Calculer le nombre de jours de disponibilité pour cette période
      var joursDisponibilite = nombreJoursEntreDeuxDates(dateDebut, dateFin) + 1;

      // Ajouter le nombre de jours de disponibilité au total
      totalJoursDisponibilite += joursDisponibilite;
    });

    return totalJoursDisponibilite;
  }

  function formatAmount(amount) {
    // Diviser par 1000 répétitivement pour obtenir le nombre en milliers (K)
    let formattedAmount = amount;
    let suffix = '';

    if (amount >= 1000000) {
      formattedAmount = amount / 1000000;
      suffix = ' Million';
    }

    if (amount >= 1000) {
      formattedAmount = amount / 1000;
      suffix = 'K';
    }

    return formattedAmount.toLocaleString('fr-FR', { maximumFractionDigits: 2 }) + suffix;
  }

  function compareDates(a, b) {
    const dateA = new Date(`${a[0].split('/')[1]}-${a[0].split('/')[0]}`);
    const dateB = new Date(`${b[0].split('/')[1]}-${b[0].split('/')[0]}`);
    return dateA - dateB;
  }

  function comparePriceDesc(property1, property2) {
    return property2.commission - property1.commission;
  }

  const handleYearChange = (e) => {
    const selected = e.target.value;
    setSelectedYear(selected);
    loadtotal(Number(selected)); // Recharger les données pour l'année sélectionnée
  };


  function groupTotalByMonthAndYear(transactions) {
    return transactions.reduce((acc, transaction) => {
      const year = transaction.date.getFullYear();
      const month = transaction.date.getMonth() + 1;
      const key = `${month < 10 ? '0' + month : month}/${year}`;

      if (!acc[year]) acc[year] = {};
      acc[year][key] = (acc[year][key] || 0) + transaction.price;

      return acc;
    }, {});
  }

  const loadtotal = (y) => {

    setL(true)
    firebase.firestore().collection('properties').get().then((snaps) => {
      let s2 = [];
      let pral = []
      snaps.forEach((d) => {
        const dr = d.data()
        dr.id = d.id;
        if (dr?.delete) {

        } else {
          s2.push(dr)
          let dssd = {
            id: dr.id,
            img: dr.gallery[0] || null,
            title: dr.nameHouse,
            type: dr?.type?.label || "",
            unit: 0,
            price: 0,
            commission: 0,
            nbdaydisp: getNumberDayOfDisp(dr?.disponibilite || []),
            nbdaybook: 0
          }
          pral.push(dssd)
        }

      })

      firebase.firestore().collection('bookings').get().then(async (snap) => {
        let s = [];
        snap.forEach((d) => {
          const dr = d.data()
          dr.id = d.id;
          if (dr?.delete) {

          } else {
            s.push(dr)
          }
        })

        let t = 0
        let c = 0;
        let tf = []
        let alltf = [];
        let tbooking = 0
        let appt = 0;
        let villa = 0;
        let boutique = 0
        let chalet = 0
        var anneeActuelle = y
        // Récupérez l'année de la date

        const formattedDates = [];



        s.forEach((sd) => { 
          if (sd?.statut?.value === 'confirmed' && sd.checkin?.seconds) {


            const maDate = new Date(sd.checkin?.toDate())
            const anneeDate = maDate.getFullYear();
            // Vérifiez si l'année de la date est égale à l'année actuelle
            alltf.push({ date: sd.checkin.toDate(), price: Number(sd?.commission?.replace(',', '.')) || 0 })
            if (anneeDate === anneeActuelle) {
              // console.log("La date tombe cette année !");

              const rawDate = sd.booked_date?.seconds ? sd.booked_date?.toDate() : null;
              if (rawDate) {
                // Formater la date en DD/MM/YYYY
                const formattedDate = format(rawDate, 'dd/MM/yyyy');
                formattedDates.push(formattedDate);
              }

              tf.push({ date: sd.checkin.toDate(), price: Number(sd?.commission?.replace(',', '.')) || 0 })
              t += Number(sd.total_pay?.replace(',', '.')) || 0

              if (sd?.apporteur?.has && sd?.apporteur?.price){
                c -= sd?.apporteur?.price || 0;
              }
              

              c += Number(sd?.commission?.replace(',', '.')) || 0


              tbooking += 1
              let pId = sd.property.value;
              s2.forEach((sdf) => {
                if (sdf.id === pId) {
                  if (sdf.type.value === "villa") {
                    villa += 1
                  }
                  if (sdf.type.value === "apartment") {
                    appt += 1
                  }

                  if (sdf.type.value === "boutique") {
                    boutique += 1
                  }

                  if (sdf.type.value === "chalet") {
                    chalet += 1
                  }
                  pral.forEach((sdsq, i) => {
                    if (sdsq.id === pId) {
                      let sdq = sdsq
                      sdq.unit = 1;
                      sdq.price += Number(sd?.total_pay?.replace(',', '.')) || 0
                      sdq.commission += Number(sd?.commission?.replace(',', '.')) || 0;
                      sdq.nbdaybook += getNumberDayOfDisp([{ first: sd.checkin.toDate(), end: sd.checkout.toDate() }])

                      if (sdq.nbdaydisp < sdq.nbdaybook) {
                        sdq.nbdaydisp = sdq.nbdaybook;
                      }

                      pral[i] = sdq
                    }
                  })
                }
              })
            }
          }
        })

        const prepareCommissionData = (data) => {
          const groupedByMonthAndYear = {};
        
          data.forEach(({ checkin, commission }) => {
            // Extraire l'année et le mois depuis `checkin`
            const date = checkin.seconds ? new Date(checkin?.toDate()) : new Date();
            const year = date.getFullYear();
            const month = date.getMonth(); // 0 = Janvier, 11 = Décembre
        
            // Convertir la commission en float et gérer les éventuelles virgules
            const parsedCommission = parseFloat(commission.replace(',', '.')) || 0;
        
            // Initialiser l'année si nécessaire
            if (!groupedByMonthAndYear[year]) {
              groupedByMonthAndYear[year] = Array(12).fill(0); // 12 mois
            }
        
            // Ajouter la commission au mois correspondant
            groupedByMonthAndYear[year][month] += parsedCommission;
          });
        
          return groupedByMonthAndYear;
        };

        const groupedByDateWithTotalPay = s.reduce((acc, reservation) => {
          if (reservation?.statut?.value === 'confirmed' && reservation.checkin?.seconds) {

            const maDate = new Date(reservation.checkin?.toDate())
            const anneeDate = maDate.getFullYear();
            const rawDate = reservation.booked_date?.seconds ? reservation.booked_date?.toDate() : null;
            if (rawDate && anneeDate === anneeActuelle) {
              // Formater la date en DD/MM/YYYY
              const formattedDate = format(rawDate, 'dd/MM/yyyy');

              // Remplacer les virgules par des points et convertir en nombre
              const totalPay = parseFloat(reservation.total_pay?.replace(',', '.')) || 0;

              // Grouper et additionner les valeurs de total_pay
              if (!acc[formattedDate]) {
                acc[formattedDate] = totalPay;
              } else {
                acc[formattedDate] += totalPay;
              }
            }
          }
          return acc;
        }, {});

        const groupedByDateWithCommission = s.reduce((acc, reservation) => {
          if (reservation?.statut?.value === 'confirmed' && reservation.checkin?.seconds) {

            const maDate = new Date(reservation.checkin.toDate())
            const anneeDate = maDate.getFullYear();
            const rawDate = reservation.booked_date?.seconds ? reservation.booked_date?.toDate() : null;
            if (rawDate && anneeDate === anneeActuelle) {
              // Formater la date en DD/MM/YYYY
              const formattedDate = format(rawDate, 'dd/MM/yyyy');

              // Remplacer les virgules par des points et convertir en nombre
              const commission = parseFloat(reservation.commission?.replace(',', '.')) || 0;

              // Grouper et additionner les valeurs de total_pay
              if (!acc[formattedDate]) {
                acc[formattedDate] = commission;
              } else {
                acc[formattedDate] += commission;
              }
            }
          }
          return acc;
        }, {});

        const doccrm = await firebase.firestore().collection('crm').get()
        const doccrmArray = doccrm.docs.map(doc => ({...doc.data(), id: doc.id}))
        // console.log("doccrmArray", doccrmArray)
        const justeBookingInDate = s.filter((reservation) => {
          if (reservation?.statut?.value === 'confirmed' && reservation.checkin && reservation.checkin?.seconds) { 
            const rawDate = new Date(reservation.checkin.seconds * 1000)
            const anneeDate = rawDate.getFullYear();
            if (anneeDate === anneeActuelle) {
              return true
            }
          }
          return false;
        }, {});

        // console.log('justeBookingInDate', justeBookingInDate)

        const onlyuser = doccrmArray.filter((user) => {
          if (user.id) {
            const book = justeBookingInDate.find((doc) => doc?.client?.value ===user.id)
            if (book) {
              return true
            }
          }
          return false;
        }) 
        setNationalitiesCrm(onlyuser)

        const sBDCommission = Object.fromEntries(
          Object.entries(groupedByDateWithCommission).sort(([dateA], [dateB]) => {
            const parsedDateA = new Date(dateA.split('/').reverse().join('-'));
            const parsedDateB = new Date(dateB.split('/').reverse().join('-'));
            return parsedDateA - parsedDateB;
          })
        );

        const sBDTP = Object.fromEntries(
          Object.entries(groupedByDateWithTotalPay).sort(([dateA], [dateB]) => {
            const parsedDateA = new Date(dateA.split('/').reverse().join('-'));
            const parsedDateB = new Date(dateB.split('/').reverse().join('-'));
            return parsedDateA - parsedDateB;
          })
        );
        // console.log("s", s)
        // setDataTP(sBDTP)
        setTvilla(villa)
        setTappt(appt)
        setChaletT(chalet)
        setBoutiqueT(boutique)
        // Grouper les dates et compter les occurrences
        const dc = formattedDates.reduce((acc, date) => {
          acc[date] = (acc[date] || 0) + 1;
          return acc;
        }, {});

        // Trier par date (du plus ancien au plus récent)
        const sortedDc = Object.fromEntries(
          Object.entries(dc).sort(([dateA], [dateB]) => {
            const parsedDateA = new Date(dateA.split('/').reverse().join('-')); // Convertir en format ISO pour tri
            const parsedDateB = new Date(dateB.split('/').reverse().join('-'));
            return parsedDateA - parsedDateB; // Comparaison des dates
          })
        );
        // setDateCount(sortedDc)


        // console.log("sortedDc", sortedDc);
        // Fusionner les deux tableaux
        const mergedData = Object.keys(sortedDc).map((date) => ({
          date,
          occurrences: sortedDc[date] || 0,
          totalPay: sBDTP[date] || 0,
          commission: sBDCommission[date] || 0
        })); 
        setDataTP(mergedData)


        const calculateCumulativeData = (mergedData) => {
          let cumulativeRevenue = 0;
          let cumulativeCommission = 0;
        
          // console.log("mergedData", mergedData)
          return mergedData.map(({ date, totalPay, commission }) => {
            // Convertir commission en float, remplacer les virgules si nécessaire
            // const parsedCommission = parseFloat(commission?.replace(',', '.')) || 0;
        
            cumulativeRevenue += totalPay;
            cumulativeCommission += commission;
        
            return {
              date,
              cumulativeRevenue,
              cumulativeCommission,
            };
          });
        };
        const cumulativeData = calculateCumulativeData(mergedData);
        setDataCD(cumulativeData)
        // Grouper les données par années et mois
        let groupedData = groupTotalByMonthAndYear(alltf);

        // Extraire les années disponibles
        let allYears = Object.keys(groupedData).sort((a, b) => b - a);
        setYears(allYears);


        // console.log('cdf', groupTotalByMonth(tf));
        let tab = []
        for (let [key, value] of Object.entries(groupTotalByMonth(tf))) {

          if (key.includes(`${anneeActuelle}`)) {
            tab.push([key, value, 0])
          }
          if (key.includes(`${Number(anneeActuelle) - 1}`)) {
            tab.push([key, 0, value])
          }
        }
        // console.log('tab', )
        tab.sort(compareDates)

        let nst = [['products', `${anneeActuelle}`, `${Number(anneeActuelle) - 1}`]]
        tab.forEach((ssd) => {
          nst.push(ssd)

        })
        setData(nst)
        settcalprice(c);
        setTCom(formatAmount(c))
        setTpay(formatAmount(t));
        setTotalBooking(tbooking)
          ;
        let npral = []
        let ddisp = 0;
        let nbdaybook = 0;
        pral.sort(comparePriceDesc)?.forEach(pr => {
          if (pr.commission > 0) {
            npral?.push(pr)
          }
          if (pr.nbdaydisp) ddisp += pr.nbdaydisp;
          if (pr.nbdaybook) nbdaybook += pr.nbdaybook;
        })
        settddisp(ddisp)
        settnbdaybook(nbdaybook)
        setproductsN(npral)
        setL(false)
        setCommissionData(s);
      })
    })

  }
  const [commissionData, setCommissionData] = useState([]);
  React.useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        setL(false)
        // loadList()
        loadtotal(new Date().getFullYear())
      } else {
        navigate('/login');
      }

    })
  }, [])

  return (
    <>
      {!l ? (<>
        <h1>Rapport</h1>
        <p>Cette page inclus un rapport simplifié des données statistiques.</p>

        {/* Liste des choix d'années */}
        <Form.Group className="mb-3">
          <Form.Label>Choisissez une année :</Form.Label>
          <Form.Control as="select" value={selectedYear} onChange={handleYearChange}>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </Form.Control>
        </Form.Group>


        <Row className="g-3 mb-3"> 
          <Col md={6} xxl={3} >
            <TotalOrder data={totalOrder} total={tpay} year={selectedYear} title={'Revenu TTC'} />
          </Col> 
          <Col sm={6} xxl={3} className="order-xxl-1">
            <BandwidthSaved tddisp={tddisp} tnbdaybook={tnbdaybook} year={selectedYear} />
          </Col>
          <Col md={6} xxl={3}>
            <TotalOrder data={totalOrder} total={tcom} year={selectedYear} title={'Commission HT'} />
          </Col>
          <Col md={6} xxl={3}>
            <WeeklySales total={totalreservation} villa={tvilla} appt={tappt} boutique={boutiquet} chalet={chalett} />
          </Col>
        </Row>
        <Row className="g-3 mb-3">

          <Col xxl={12} md={12}>
          <CommissionBarChart data={commissionData} />
            {/* <TopProducts data={data} className="h-100" /> */}
          </Col>   
         <Col xxl={12} md={12}>
            <ChartBDTP data={dataTP} />
          </Col>
         <Col xxl={12} md={12}>
            <ChartCA data={dataCD} />
          </Col>

          
        </Row>
        <Row className="g-3 mb-3">
          <Col lg={12} xl={12}>
          <NationalityStats crm={nationalitiesCrm} annee={selectedYear} />
          </Col>
        </Row>




        <Row className="g-3 mb-3">
          <Col lg={12} xl={12}>
            <BestSellingProducts products={productsN} tprice={tcom} tcalprice={tcalprice} />
          </Col>
        </Row>
      </>) : <p>Chargement {selectedYear}...</p>}
    </>
  );
};

export default Rapports;
